export class OloApiError {
    message: string;
    num: number;

    public static Make(obj: any): OloApiError {
        const oloApiError = new OloApiError();
        Object.assign(oloApiError, obj);
        return oloApiError;
    }
}
